export default __webpack_public_path__ + "static/p3-eceb5bc44380d8b0a3ebdc1b99953d9d.png";